export default {
    get_airport_list : (state) => state.airport_list,
    get_avaibles : (state) => state.avaibles,
    get_avaible_15_days : (state) => state.avaible_15_days,
    get_selected_ticket : (state) => state.selectedTicket,
    get_selected_source : (state) => state.selectedSource,
    get_selected_destination : (state) => state.selectedDestination,
    get_ticket_user_info : (state) => state.ticket_user_info,
    get_captcha : (state) => state.captcha,
    get_passengers_count : (state) => state.passengers_count,
}
